import { CheckIcon, Copy06Icon } from '@langchain/untitled-ui-icons';

import React from 'react';

import { Button, IconButton } from '@/design-system';

import { useCopy } from './useCopy';

export function CopyButton(props: {
  copy: string;
  variant?: 'full' | 'icon';
  className?: string;
  copyText?: string;
}) {
  const { copied, onCopy } = useCopy({ copy: props.copy });

  if (props.variant === 'icon') {
    return <CopyIconButton copy={props.copy} copyText={props.copyText} />;
  }

  return (
    <Button
      size="sm"
      leftDecorator={copied ? CheckIcon : Copy06Icon}
      color="secondary"
      variant="outlined"
      onClick={(event) => {
        event.stopPropagation();
        onCopy();
      }}
      className={props.className}
    >
      {copied ? 'Copied' : props.copyText ?? 'Copy'}
    </Button>
  );
}

export function CopyIconButton(props: {
  copy: string;
  className?: string;
  copyText?: React.ReactNode;
}) {
  const { copied, onCopy } = useCopy({ copy: props.copy });

  return (
    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        onCopy();
      }}
      icon={copied ? CheckIcon : Copy06Icon}
      label={'copy-button'}
      tooltipProps={{
        title: copied ? 'Copied' : props.copyText ?? 'Copy',
        side: 'top',
      }}
      variant="plain"
      color="secondary"
      size="sm"
    />
  );
}
